import { Button, CircularProgress } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
import Stack from "@mui/material/Stack";
import React from "react";
import "./primaryButton.css";

const PrimaryButton = (props) => {
  const theme = createTheme({
    palette: {
      primary: {
        main: grey[500],
        contrastText: "#000",
      },
    },

    typography: {
      fontFamily: "Gilroy-Medium",
      fontSize: 17,
    },
  });

  const buttonType = props?.isSubmit ? "submit" : "button";

  return (
    <ThemeProvider theme={theme}>
      <Stack spacing={2} direction="row">
        <Button
          className={
            props.className
              ? `${props.className} primary_cmn_btn mediumFont`
              : `${props.disabled}`
              ? "primary_cmn_btn mediumFont disabled"
              : "primary_cmn_btn mediumFont"
          }
          size={props.size || "large"}
          style={props.style}
          variant="contained"
          disabled={props.disabled || props.loading || false}
          onClick={props.onClick}
          type={buttonType} // Set the button type
        >
          {props?.loading ? (
            <CircularProgress className="progress_bar" />
          ) : (
            props.label
          )}
        </Button>
      </Stack>
    </ThemeProvider>
  );
};

export default PrimaryButton;
